import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { AccountStatement, AnnualStatement, Invoice, InvoiceYearlyPayment, Settlement, SettlementLine } from "interface/accounting";
import { FilterOption } from "interface";

export interface SettlementFilter extends  Omit<FilterOption, "vesselRegistrationNumber" >{
    vesselLedgerAccountNumber? : string,
    settlementNumber?: string,
    vesselHullId?: number,
    vesselName?: string,
    vesselId?: string
}
 
export interface InvoiceFilter extends  Omit<FilterOption, "vesselRegistrationNumber" >{
    buyerLedgerAccountNumber? : string,
    // buyerId?: string,
     buyerName?: string,
     invoiceNumber?:   string
}
export interface AnnualStatementFilter extends  Omit<FilterOption, "vesselRegistrationNumber" >{
    vesselLedgerAccountNumber? : string,
    vesselName? : string
    vesselId?: string
}

export interface AccountStatementFilter {
    buyerLedgerAccount: number;
    buyerName?: string;
    year: number;
     monthFrom?:number
     monthTo?:number
}


export async function getSettlementsApi(filter: SettlementFilter) {
    const apiUri = "Accounting/Settlements"
    try {
        const settlements = await AxiosApi.get<ApiResponse<Settlement[]>>(apiUri, {
            params: filter
        })

        //console.log('settlements', settlements.data);

        return settlements.data
    } catch (error) {
 
        throw error
    } 
}

export async function getAccountStatementApi(filter: AccountStatementFilter) {
    const apiUri = "Accounting/AccountStatement";
    const statement = await AxiosApi.get<ApiResponse<AccountStatement[]>>(apiUri, {
        params: filter,
    });
    return statement.data;
}

export async function getAccountStatementYearsApi(buyerLedgerAccount: number) {
    const apiUri = "Accounting/AccountStatementYears";
    const years = await AxiosApi.get<ApiResponse<number[]>>(apiUri, {
        params: { buyerLedgerAccount },
    });
    return years.data;
}

export async function getAccountStatementPeriodsApi(
    buyerLedgerAccount: number,
    year: number,
) {
    const apiUri = "Accounting/AccountStatementPeriods";
    const periods = await AxiosApi.get<ApiResponse<number[]>>(apiUri, {
        params: { buyerLedgerAccount, year },
    });
    return periods.data;
}
export async function getSettlementLinesApi( settlementId: string ) {
    const apiUri = "Accounting/SettlementLines"

    try {
        const settlementsLines = await AxiosApi.get<ApiResponse<SettlementLine[]>>(apiUri, {
            params: {
                settlementId
            }
        })
        return settlementsLines.data
    } catch (error) {
        throw error
    } 
}




///-------------- Invoice ------ //////

export async function getInvoicesApi( filter: InvoiceFilter   ) {
    const apiUri = "Accounting/Invoices"

    try {
        const invoices = await AxiosApi.get<ApiResponse<Invoice[]>>(apiUri, {
            params: filter
        })
        console.log('data', invoices.data);
        return invoices.data
    } catch (error) {
        throw error
    } 
}

export async function getInvoicedYearPaymentApi( year?:number   ) {
    const apiUri = "Accounting/InvoicesYearlyPayment"

    try {
        const invoices = await AxiosApi.get<ApiResponse<InvoiceYearlyPayment>>(apiUri, {
            params: {year}
        })
        return invoices.data
    } catch (error) {
        throw error
    } 
}


////---------------  Annual Statement --------- //////

export async function getAnnualStatementApi( filter:AnnualStatementFilter  ) {
    const apiUri = "Accounting/AnnualStatements"

    try {
        const invoices = await AxiosApi.get<ApiResponse<AnnualStatement[]>>(apiUri, {
            params: filter
        })
        return invoices.data
    } catch (error) {
        throw error
    } 
}
